import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-price-table',
  templateUrl: './price-table.component.html',
  styleUrls: ['./price-table.component.scss']
})
export class PriceTableComponent implements OnInit {
  params;

  constructor() {
  }

  ngOnInit() {
  }

  agInit(params: any): void {
    this.params = params;
  }

}
